import React from 'react';
import NumberFormat from 'react-number-format';

function PhoneField(props) {
  const { inputRef, onChange, ...other } = props;
  console.log('PhoneField', props);
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      format="+# (###) ###-####"
      mask="_"
    />
  );
}

export default PhoneField;
